import { clearAccessToken, useLogoutUserMutation } from '@massilia/queries'
import { useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { useAuthStore } from '@/stores/auth.store'

/**
 * Déconnexion de l'espace client. Extraite de la page « Mon profil » depuis que
 * le menu mobile porte lui aussi le bouton : une seule séquence, un seul endroit
 * où la corriger.
 *
 * L'échec de l'appel serveur ne bloque pas : le jeton local est purgé quoi qu'il
 * arrive, sinon un serveur indisponible enfermerait le client dans une session
 * qu'il ne peut plus quitter.
 */
export function useLogout() {
  const { updateAuth } = useAuthStore()
  const navigate = useNavigate()
  const { mutateAsync: logout } = useLogoutUserMutation()

  return useCallback(async () => {
    try {
      await logout()
    } catch {
      // Volontairement silencieux : voir le commentaire ci-dessus.
    }
    clearAccessToken()
    updateAuth({ isAuthenticated: false, user: undefined })
    void navigate({ to: '/connexion' })
  }, [logout, navigate, updateAuth])
}
